// extracted by mini-css-extract-plugin
module.exports = {"block":"detailPage_block__2BC16","block_info":"detailPage_block_info__fY9Bs"};